<template>
  <div id="home" class="apps">
    <el-container class="side-container">
      <el-aside class="side" width="200px">
        <div>
          <h1>安全检查后台管理</h1>
        </div>
        <el-menu :default-active="$route.path" router>
          <!-- @open="handleOpen" -->
          <el-submenu index="/baseData">
            <template slot="title"
              ><i class="el-icon-s-management"></i>基础数据维护</template
            >
            <el-menu-item-group>
              <el-menu-item index="/baseData/ClassInformation"
                >安全检查分类信息</el-menu-item
              >
              <el-menu-item index="/baseData/EntryInformation"
                >安全检查条目信息</el-menu-item
              >
              <el-menu-item
                class="checklist"
                :class="{ 'is-active': isActive }"
                index="/baseData/ChecklistTemp"
                >检查表模板</el-menu-item
              >
              <el-menu-item index="/baseData/ProjectTemp"
                >项目模板</el-menu-item
              >
              <el-menu-item index="/baseData/CheckObj"
                >检查对象类型</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="/combination">
            <template slot="title"
              ><i class="el-icon-s-management"></i>组织结构</template
            >
            <el-menu-item-group>
              <el-menu-item index="/combination/Organlist"
                >机构列表</el-menu-item
              >
              <el-menu-item index="/combination/PersonManage"
                >人员管理</el-menu-item
              >
              <!-- <el-menu-item index="/combination/RoleManage">角色管理</el-menu-item> -->
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main class="main">
        <div class="main-top">
          <div id="name" style="float: right;margin-top: 14px;">{{user_name}}</div>
          <div id="userAvatar">
            <el-dropdown>
              <span class="el-dropdown-link">
                <el-avatar
                  shape="square"
                  icon="el-icon-user-solid"
                ></el-avatar>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><span @click="dialogFormVisible = true">修改密码</span></el-dropdown-item>
                <el-dropdown-item><span @click="exit">退出登录</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
        <div class="main-view">
          <div class="top-breadcrumb" style="padding-left:20px;">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item
                v-for="(item, index) of $route.matched"
                :key="index"
              >
                <router-link :to="item.path" style="color: #000">{{
                  item.meta.title
                }}</router-link>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <router-view></router-view>
        </div>

        <el-dialog
          :before-close="cancelModifyPwd"
          title="修改密码"
          :visible.sync="dialogFormVisible"
          width="20%"
          top="20vh"
        >
          <el-form ref="pwdForm" :model="pwd" :rules="pwdRulers">
            <el-form-item label="原密码" prop="oldPwd">
              <el-input
                v-model="pwd.oldPwd"
                autocomplete="off"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码"  prop="newPwd" >
              <el-input
                v-model="pwd.newPwd"
                autocomplete="off"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="conPwd">
              <el-input
                v-model="pwd.conPwd"
                autocomplete="off"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="okModifyPwd"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { eventBus } from "../../eventbus";
import {logout,updatePassword} from '@/apis/login'
export default {
  name: "home",
  data() {
    var validateConPwd = (rule, value, callback) => {
      if(value !== this.pwd.newPwd){
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    var validateNewPwd = (rule, value, callback) => {
      if(value === this.pwd.oldPwd){
        callback(new Error('新密码不能和原密码相同!'));
      } else {
        callback();
      }
    }
    return {
      dialogFormVisible:false,
      pwd:{
        oldPwd:'',
        newPwd:'',
        conPwd:''
      },
      pwdRulers:{
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validateNewPwd, trigger: 'blur' }
        ],
        conPwd: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateConPwd, trigger: 'blur' }
        ],
      },
      sidebarItem: "",
      isActive: this.$store.state.isActive,

      form: {},
      user_name: "",
    };
  },
 
  components: {},
  watch: {
    $route: "init",
  },
  mounted() {
    this.sidebarItem = this.$route.name;
    eventBus.$on("setClass", (data) => {
      this.isActive = data;
    });
    this.user_name = this.$store.getters.userInfo.user_name;
  },
  methods: {
    okModifyPwd(){
      this.$refs.pwdForm.validate(valid=>{
        if(valid){
          updatePassword({
            origin_password:this.pwd.oldPwd,
            new_password:this.pwd.newPwd,
            confirm_password:this.pwd.conPwd
          }).then(res=>{
            if(res.data.status == "1"){
              this.dialogFormVisible = false
              this.$message("修改成功")
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              });
            }
          })
        }
      })
    },
    cancelModifyPwd(){
      this.pwd = {
        oldPwd:'',
        newPwd:'',
        conPwd:''
      },
        this.dialogFormVisible = false
    },
    // handleMenuItemClick(name){
    //     console.log('name',name);
    //     this.$router.push({path:name});
    //     this.currentMenuIndex= name;
    // },
    init() {
    },
    exit() {
      logout().then((res) => {
        this.$router.push({ path: "/" });
      });
    },
  },
};
</script>
<style  scoped>
.side-container {
  height: 100vh;
  border: 1px solid #eee;
}
#home .el-aside {
  background-color: #fff;
  border-right:1px solid #E8E8E8;
  box-sizing:content-box;
}
#home >>> .el-menu {
  background-color: #fff;
  text-align: left;
  border-right:none;
}
#home >>> .el-submenu__title {
  color: #000;
}
/* 左边菜单选中时的样式 */
/* #home >>> .el-submenu.is-active .el-submenu__title {

    border-bottom-color:#bfbfbf
} */

.main-top {
  padding:0 20px;
  border-bottom: 1px solid #ccc;
  position:relative;
  height:50px;
}
.el-main {
  padding: 0px;
}
.el-submenu__title i {
  /* color: #909399; */
  color: #000;
}
#home >>> .el-submenu__icon-arrow {
  font-size: 14px;
}
.checklist.is-active {
  background-color: #bfbfbf !important;
  color: #000;
}
.el-dropdown :hover {
  background: #c0c4cc;
}
#userAvatar {
  width: 40px !important;
  height: 40px !important;
  float:right;
  position:relative;
  right:10px;
  margin-top:5px;
}
.el-avatar--icon {
  font-size: 28px;
  color: #000;
}
.el-avatar {
  background: #fff;
}

.el-breadcrumb__item{
  height:25px;
  line-height:25px;
  vertical-align:middle;
}

</style>



// WEBPACK FOOTER //
// src/views/backStage/home.vue